export const PLOT_RECORDING_OVERLAY_REDRAW_EVENT = "plot-recording-overlay-redraw";
export const PLOT_RECORDING_PREPARE_SNAPSHOT_EVENT = "plot-recording-prepare-snapshot";
